export const ADDITIONAL_TAX_ORIGIN = {
  CUSTOMERS_PANEL: 'customers-panel',
} as const;
